// extracted by mini-css-extract-plugin
export default {"root":"no_items-module___root___efc27e2e"};